import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';

import Dialog, { DialogTitle, DialogContentText,DialogContent,DialogActions } from 'material-ui/Dialog';

import Typography from 'material-ui/Typography/Typography';
import { ajaxPost } from '../ajax';

const styles = theme => ({
      wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
        display:'inline-flex',
      },
});

class EnrollStatus extends Component {
        state = 
        {
            message : "Waiting for device to connect..."
        }

        componentDidMount = () =>
        {
            var _parent2 = this.props._parent2;
            var _id2 = this.props.DeviceCommandID;

            var fn = () =>
            {
                if( _parent2.state.enrollStatus == false )
                    return;

                ajaxPost({
                    url:'/DeviceCommandAPI/GetStatusUpdates',
                    data:[_id2],
                    onSuccess: data =>
                    {
                        switch( data[0].Status )
                        {
                            case 'SENT':
                                this.setState({message:'Device is now ready.  Please proceed to the device for enrollment'})
                                setTimeout( fn, 1000);
                                break;
                            case 'SUCCESS':
                                this.setState({message:'Registration has been completed SUCCESSFULLY'})
                                break;
                            case 'FAILED':
                                this.setState({message:'Registration FAILED'})
                                break;
                            default:
                                setTimeout( fn, 1000);
                        }

                    },
                    finally:()=>{}
                }
                );
                        
            }

            setTimeout( fn, 500 );
        }
    

        render = ()=>
        {
            const {classes} = this.props;

            return (
                <div>
                    
            <Dialog
            open={true}
            aria-labelledby="form-dialog-title"
            classes={classes}
            >
            <DialogTitle>Enroll Fingerprint</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <div style={{width:350}}>{this.state.message}</div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            <div className={classes.wrapper}>
                <Button 
                color="primary" className={classes.button} onClick={this.props.onAction.bind(this)}>
                CLOSE
                </Button>
            </div>
            </DialogActions>
            </Dialog>            
            </div>
            )
        }
}

export default withStyles(styles)(EnrollStatus);


// WEBPACK FOOTER //
// ./src/admin/EnrollStatus.js